/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';

import ImageButton from './ImageButton';
import ArrowLeft from 'components/images/ArrowLeft';

const BackButton = ({ onClick }) => (
  <ImageButton onClick={onClick}>
    <ArrowLeft fillColor="gray" />
  </ImageButton>
);
BackButton.propTypes = {
  onClick: PropTypes.func,
};

export default BackButton;